import React, { useEffect, useMemo, useState } from "react";

import PageTitle from "../PageTitle";
import PageSearch from "../PageSearch";
import DialogBox from "../../components/dialog-box/DialogBox";
import EnhancedTable from "../table/Table";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { displayDateFormart, isValidArr } from "../../utility/utils";
import { fetchSBUBUMaps } from "../../redux/actions/SBUBUMapActions";
import { fetchSBUs } from "../../redux/actions/SBUActions";
import { fetchBUs } from "../../redux/actions/BUActions";
import Loader from "../../components/loader/Loader";
import { SBUBUMapModel } from "../../models/SBUBUMapModel";
import SBUBUMappingForm from "./SBUBUMappingForm";

export type Mode = "add" | "delete";

type iData = {
  id: string;
  sbuName: string;
  buName: string;
  createdDate: string;
  // status: string;
};

const SBUBUMappingPage = () => {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mode, setMode] = useState<Mode>("add");
  const [editData, setEditData] = useState<SBUBUMapModel>();
  const [rootData, setRootData] = useState<iData[]>([]);
  const [filteredData, setFilteredData] = useState<iData[]>([]);

  const allSBUBUs = useAppSelector((state) => state.SBUBUMapMap.all_sbu_bu_Map);
  const allSBUs = useAppSelector((state) => state.sbu.all_SBUs);
  const allBUs = useAppSelector((state) => state.bu.all_BUs);

  const isSBUBUMapsFetching = useAppSelector(
    (state) => state.SBUBUMapMap.isSBUBUMapsFetching
  );

  //To fetch all SBUs, BUs, SBU-BUs
  useEffect(() => {
    dispatch(fetchSBUBUMaps());
    dispatch(fetchSBUs());
    dispatch(fetchBUs());
  }, [dispatch]);

  const columns = useMemo(() => {
    return [
      {
        id: "sbuName",
        numeric: false,
        disablePadding: false,
        label: "SBU",
      },
      {
        id: "buName",
        numeric: false,
        disablePadding: false,
        label: "BU",
      },
      {
        id: "createdDate",
        numeric: false,
        disablePadding: false,
        label: "Created Date",
        width: 150,
      },
      // {
      //   id: "status",
      //   numeric: false,
      //   disablePadding: false,
      //   label: "Status",
      // },
    ];
  }, []);

  useEffect(() => {
    setRootData(() =>
      allSBUBUs.map((sbubu) => {
        const SBUName = allSBUs.find((rec) => rec.sbuid === sbubu.sbuid);
        const BUName = allBUs.find((rec) => rec.buid === sbubu.buid);
        return {
          id: `${sbubu.sbuid}|${sbubu.buid}`,
          sbuName: SBUName ? SBUName.name : "",
          buName: BUName ? BUName.name : "",
          createdDate: displayDateFormart(sbubu.createdDate),
          // status: sbubu.isActive ? "Active" : "Inactive",
        };
      })
    );
  }, [allSBUs, allBUs, allSBUBUs]);

  // To set filtered data on change root data
  useEffect(() => {
    setFilteredData(rootData);
  }, [rootData]);

  const handleEdit = (id: string | number) => {
    const idArr = id.toString().split("|");
    const editRec = allSBUBUs.find(
      (rec) => rec.sbuid === +idArr[0] && rec.buid === +idArr[1]
    );
    setMode("delete");
    setEditData(editRec);
    setIsModalOpen(true);
  };

  const createHandler = () => {
    setMode("add");
    setEditData(undefined);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const searchHandler = (searchVal: string): void => {
    setFilteredData(() =>
      searchVal
        ? rootData.filter((info) =>
            Object.values(info).join("").toLowerCase().includes(searchVal)
          )
        : rootData
    );
  };

  return (
    <>
      {!isValidArr(allSBUBUs) && isSBUBUMapsFetching ? <Loader /> : null}
      <PageTitle
        title="SBU-BU Mapping"
        btnText="Add SBU-BU Map"
        onClick={createHandler}
      />
      <PageSearch
        placeholder="Search SBU-BU Maps"
        searchHandler={searchHandler}
      />
      <EnhancedTable
        columns={columns}
        data={filteredData}
        handleEdit={handleEdit}
        isEditable={false}
      />
      {isModalOpen && (
        <DialogBox
          isModalOpen={isModalOpen}
          modalTitle={
            mode === "add" ? "Create SBU-BU Map" : "Delete SBU-BU Map"
          }
          handleModalClose={handleModalClose}
        >
          <SBUBUMappingForm
            mode={mode}
            data={editData}
            handleModalClose={handleModalClose}
          />
        </DialogBox>
      )}
    </>
  );
};

export default SBUBUMappingPage;
